import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import home from '../assets/Path 13.svg';
import history from '../assets/Path 14.svg';
import profile from '../assets/27e06fbd92f13d40bb41991bcd741a47.svg';

export default function NavbarBottom({ auth }) { // ✅ Receive auth prop
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active route
  const isActive = (path) => location.pathname === path;

  // ✅ Allow navigation if auth is null, empty, or true
  const canNavigate = auth === null || auth === "" || auth === undefined || auth === true;

  const handleRedirect = (path) => {
    if (canNavigate) {
      navigate(path);
    }
  };

  return (
    <div className='bottom-navbar'>
      <div
        className='container pt-3 pb-2'
        style={{ background: 'black', borderRadius: '15px' }}
      >
        <div className='row'>
          <div className='col-12'>
            <div className='d-flex w-100 justify-content-around'>

              {/* Home */}
              <div
                className='d-flex flex-column align-items-center gap-3'
                style={{
                  cursor: canNavigate ? 'pointer' : 'not-allowed',
                  color: isActive('/Portal/index.html') ? 'white' : '#707070',
                  opacity: canNavigate ? 1 : 0.5,
                }}
                onClick={() => handleRedirect('/Portal/index.html')}
              >
                <img
                  src={home}
                  style={{
                    filter: isActive('/Portal/index.html')
                      ? 'invert(0%)'
                      : 'invert(40%) sepia(4%) saturate(0%) hue-rotate(316deg) brightness(90%) contrast(85%)',
                  }}
                  alt='Home'
                />
                <h2 style={{ color: isActive('/Portal/index.html') ? 'white' : '#707070' }}>
                  Home
                </h2>
              </div>

              {/* History */}
              <div
                className='d-flex flex-column align-items-center gap-3'
                style={{
                  cursor: canNavigate ? 'pointer' : 'not-allowed',
                  color: isActive('/Portal/history') ? 'white' : '#707070',
                  opacity: canNavigate ? 1 : 0.5,
                }}
                onClick={() => handleRedirect('/Portal/history')}
              >
                <img
                  src={history}
                  style={{
                    height: '2.5rem',
                    filter: isActive('/Portal/history')
                      ? 'invert(0%)'
                      : 'invert(40%) sepia(4%) saturate(0%) hue-rotate(316deg) brightness(90%) contrast(85%)',
                  }}
                  alt='History'
                />
                <h2 className='p-0 m-0' style={{ color: isActive('/Portal/history') ? 'white' : '#707070' }}>
                  History
                </h2>
              </div>

              {/* Profile */}
              <div
                className='d-flex flex-column align-items-center gap-3'
                style={{
                  cursor: canNavigate ? 'pointer' : 'not-allowed',
                  color: isActive('/Portal/profile') ? 'white' : '#707070',
                  opacity: canNavigate ? 1 : 0.5,
                }}
                onClick={() => handleRedirect('/Portal/profile')}
              >
                <img
                  src={profile}
                  style={{
                    filter: isActive('/Portal/profile')
                      ? 'invert(0%)'
                      : 'invert(40%) sepia(4%) saturate(0%) hue-rotate(316deg) brightness(90%) contrast(85%)',
                  }}
                  alt='Profile'
                />
                <h2 style={{ color: isActive('/Portal/profile') ? 'white' : '#707070' }}>
                  Profile
                </h2>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
